import { exists } from "application/functions";
import { clone, filter } from "ramda";
import { SHIPPING_COST } from "application/constants/app-constants";
import getRegion from "./getRegion";
import getMarket from "./getMarket";
import getCurrency from "./getCurrency";
import getCountry from "./getCountry";
import getLang from "./getLang";
import getMarketDescription from "./getMarketDescription";
import { isNil } from "ramda";

export default function modifyRepetibleIndex(value, price, otherPrices) {
  const lang = getLang() || getCountry() || navigator.language || navigator.userLanguage;
  const language = lang ?? "en";
  const countries = ["fr", "en"];
  const _lang = language === "en" || !countries.includes(language) ? "en" : language;
  //no quitar los "raíz"
  const newValue = clone(value);
  if (exists(newValue.garment)) {
    newValue.garment = filter((j) => exists(j), value.garment);
    newValue.garment.forEach((j, i) => {
      newValue.garment[i].garment.arrangement_group = filter((t) => exists(t), j?.garment?.arrangement_group ?? []);
    });
  }
  //add rest
  newValue.region = { value: getRegion() };
  newValue.market = { value: getMarket() };
  newValue.marketDescription = { value: getMarketDescription() };
  newValue.currency = { value: getCurrency() };
  newValue.language = { value: _lang };
  newValue.shipping_costs = { value: SHIPPING_COST };
  newValue.shipping_costs_with_taxes = { value: SHIPPING_COST };
  newValue.accept_terms = { value: true };
  newValue.accept_service = { value: true };
  newValue.price = { value: price };
  newValue.priceWithTaxes = { value: price };

  if (!isNil(otherPrices)) {
    newValue.priceWithoutDiscount = { value: otherPrices.arrangementsPriceWithoutDiscount };
    newValue.discount = { value: otherPrices.arrangementsDiscount };
  } else {
    newValue.priceWithoutDiscount = { value: price };
    newValue.discount = { value: 0 };
  }
  return newValue;
}
